const firebaseConfig = {
    apiKey: "AIzaSyBkn4icPITb6O575yNid_u4PiXNX2QPG4U",
    authDomain: "baby-care-online-shop.firebaseapp.com",
    projectId: "baby-care-online-shop",
    storageBucket: "baby-care-online-shop.appspot.com",
    messagingSenderId: "75876231364",
    appId: "1:75876231364:web:b0fd9408b5903f60774191",
    measurementId: "G-WR3WJKSGPQ"
  };

  export default firebaseConfig;